<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title" style="text-align: center;">Payment Method</h4>
    </div>
    <div class="card-content" style="text-align: center;">
      <div v-if="!creditCard.update">
        <h5>{{ creditCard.display }}</h5>
        <button class="btn btn-sm" @click.prevent="updateCard()">Update Card</button>
      </div>
      <form v-if="creditCard.update" method="#" action="#" @submit.prevent="submit()">
        <div>
          <h6>New Credit Card</h6>
          <div>
            <div class="form-group">
              <card class='stripe-card'
                :class='stripeSettings.class'
                :stripe='stripeSettings.pubKey'
                :options='stripeSettings.options'
                :style='stripeSettings.style'
                @change='complete = $event.complete'
              />
            </div>
          </div>
          <div>
            <button type="button" v-if="!creditCard.loadingSubmit" @click.prevent="submit()" class="btn btn-fill btn-danger btn-wd">Submit</button>
            <button type="button" v-if="creditCard.loadingSubmit" class="btn btn-wd btn-danger" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  import firebase from 'firebase'
  import swal from 'sweetalert2'
  import { Card, createToken } from 'vue-stripe-elements-plus'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  export default {
    components: { Card },
    mixins: [toolboxMixin],
    data () {
      return {
        stripeSettings: {
          pubKey: process.env.STRIPE_PUB_KEY,
          options: {
            // see https://stripe.com/docs/stripe.js#element-options for details
            classes: {
              base: 'form-control'
            }
          },
          class: {
            complete: false
          },
          style: {
            base: {
              color: 'yellow',
              fontFamily: 'inherit',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          }
        },
        creditCard: {
          display: 'Loading...',
          update: false,
          loadingSubmit: false,
          stripeToken: ''
        }
      }
    },
    methods: {
      init () {
        this.getCreditCard()
      },
      async getCreditCard () {
        let userToken = await firebase.auth().currentUser.getIdToken()
        let data = {
          userToken: userToken
        }
        let getAccountStripeCustomer = firebase.functions().httpsCallable('getAccountStripeCustomer')
        let result = await getAccountStripeCustomer(data)
        console.log(result)
        let ccData = result.data.customer.sources.data[0]
        this.creditCard.display = ccData.brand + ': x' + ccData.last4
      },
      updateCard () {
        this.creditCard.update = true
      },
      submit () {
        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        this.creditCard.loadingSubmit = true
        createToken().then((data) => {
          if (data.error) {
            swal.fire({
              title: 'Error',
              text: data.error.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            this.creditCard.loadingSubmit = false
          } else {
            console.log('stripe token')
            console.log(data.token.id)
            this.creditCard.stripeToken = data.token.id
            this.submitCardUpdate()
            // this.createStripeSubscription(data.token.id)
          }
        })
      },
      async submitCardUpdate () {
        console.log('updating card')
        let data = {}
        data.userToken = await firebase.auth().currentUser.getIdToken()
        data.stripeToken = this.creditCard.stripeToken
        let updateAccountStripeCard = firebase.functions().httpsCallable('updateAccountStripeCard')
        updateAccountStripeCard(data)
        .then(result => {
          console.log(result)
          let ccData = result.data.customer.sources.data[0]
          this.creditCard.display = ccData.brand + ': x' + ccData.last4
          this.creditCard.update = false
          swal.fire({
            title: `Success!`,
            text: 'Your credit card was changed',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          }).then(() => {
            // do nothing
          })
        })
        .catch(err => {
          console.error(err.message)
        })
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/partials/PaymentMethod.vue